module.exports = __webpack_public_path__ + "static/illustration-checklist@2x-99b1e4db7f9c7b0514740e2173bd586c.png";